import { useEffect, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase.config';
import { toast } from 'react-toastify';
import Masonry from 'react-masonry-css';
import ProductCard from '../components/UI/ProductCard';

const Grotto = () => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);

    const breakpointColumnsObj = {
        default: 4,
        1200: 3,
        800: 2,
        500: 1
    };
    

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "products"));
                const productsList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                const filteredProducts = productsList.filter(item => item.category === 'grotto');

                // Sort products by type: T-Shirts first, followed by Posters, then Carpets
                const sortedProducts = filteredProducts.sort((a, b) => {
                    const order = { tshirt: 1, poster: 2, carpet: 3 };
                    return order[a.productType] - order[b.productType];
                });
                setData(sortedProducts);
            } catch (error) {
                toast.error("Error fetching products: ", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    return (
        <div style={{minHeight: '100vh', backgroundColor: '#000'}}>
          <section id='#products' className='section'>
              <Container>
                  <Row className='gallery'>
                      {loading && <div> Loading Products... </div>}
                        <Masonry
                            breakpointCols={breakpointColumnsObj}
                            className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column"
                            >
                            {data?.map((item, index) => (
                                <div key={index}>
                                <ProductCard item={item} wrapWithCol={false} />
                                </div>
                            ))}
                        </Masonry>
                  </Row>
              </Container>
          </section>
        </div>
    )
}

export default Grotto